/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Progress_AriaInputs */



/**
* | output |
* | --- |
* | "Export progress" |
*
* @param {Video_Export_Progress_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_progress_aria = /** @type {((inputs?: Video_Export_Progress_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Progress_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression de l'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportfortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanzamento dell'esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прогресс экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de la exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートの進捗状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso das exportações")
	return /** @type {LocalizedString} */ ("Export progress")
});